import React, { createContext, useContext, useState } from 'react';

const AgentContext = createContext();
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const AgentProvider = ({ children }) => {
  const [agent, setAgent] = useState(() => {
    try { const s = localStorage.getItem('dhs-agent'); return s ? JSON.parse(s) : null; } catch { return null; }
  });

  const _persist = (token, email, name) => {
    const a = { email, name, role: 'agent', token };
    localStorage.setItem('dhs-agent', JSON.stringify(a));
    setAgent(a);
  };

  // Step 1 — request OTP (agent must be status='active')
  const requestLoginOtp = async (email) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/otp/send`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), purpose: 'login' }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Could not send code' };
      return { ok: true };
    } catch { return { ok: false, error: 'Network error, please try again.' }; }
  };

  // Step 2 — verify OTP → JWT
  const verifyLoginOtp = async (email, code) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/otp/verify`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), code: code.trim(), purpose: 'login' }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Incorrect or expired code' };
      if (j.role !== 'agent') return { ok: false, error: 'This account is not an agent.' };
      _persist(j.token, email, j.name);
      return { ok: true };
    } catch { return { ok: false, error: 'Network error, please try again.' }; }
  };

  // Self-registration — creates a pending_approval agent record
  const registerAgent = async ({ name, email, phone, notes }) => {
    try {
      const res = await fetch(`${BACKEND}/api/agent/register`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: (name || '').trim(),
          email: (email || '').trim().toLowerCase(),
          phone: (phone || '').trim(),
          notes: (notes || '').trim(),
        }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Could not submit application' };
      return { ok: true, message: j.message };
    } catch { return { ok: false, error: 'Network error, please try again.' }; }
  };

  const logout = () => { localStorage.removeItem('dhs-agent'); setAgent(null); };

  return (
    <AgentContext.Provider value={{ agent, requestLoginOtp, verifyLoginOtp, registerAgent, logout }}>
      {children}
    </AgentContext.Provider>
  );
};

export const useAgent = () => useContext(AgentContext);
